module.exports = __webpack_public_path__ + "img/hs-06.0ad37f97.svg";